import { Component, Input } from "@angular/core";
import { ChanceNodeActionDto } from "@api";
import { ModalController } from "@ionic/angular";
import { ActionSelectorPage } from "../action-selector/action-selector.page";

@Component({
  selector: "app-multi-action",
  templateUrl: "./multi-action.page.html",
  styleUrls: ["./multi-action.page.scss"],
})
export class MultiActionPage {
  @Input() public chanceNodeId: string;
  @Input() public reason: boolean;

  constructor(private modalController: ModalController) {}

  public dismiss(): void {
    this.modalController.dismiss();
  }

  public async addAction(): Promise<void> {
    const modal = await this.modalController.create({
      component: ActionSelectorPage,
      componentProps: { reason: this.reason, chanceNodeId: this.chanceNodeId },
      cssClass: ["--select-action-modal"],
      showBackdrop: true,
      presentingElement: await this.modalController.getTop(),
      swipeToClose: true,
    });

    await modal.present();
  }

  public async editAction(chanceNodeAction: ChanceNodeActionDto): Promise<void> {
    const modal = await this.modalController.create({
      component: ActionSelectorPage,
      componentProps: {
        chanceNodeAction,
        reason: this.reason,
        actionId: chanceNodeAction.actionId,
        chanceNodeId: chanceNodeAction.chanceNodeId,
        parameters: chanceNodeAction.parameters,
      },
      cssClass: ["--select-action-modal"],
      showBackdrop: true,
      presentingElement: await this.modalController.getTop(),
      swipeToClose: true,
    });

    await modal.present();
  }
}
